/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Flex,
  Link,
  Switch,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from '@tonic-one/react';
import isEqual from 'lodash/isEqual';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import ButtonTab from 'src/components/Common/ButtonTab';
import { FormLabel, TitleLabel } from 'src/components/Common/FormComponent';
import NotifyAdmin from 'src/components/FilterNotification/NotifyAdmin';
import NotifyUser from 'src/components/FilterNotification/NotifyUser';
import {
  DlpPolicyItem,
  EnableDisableStatus,
} from 'src/pages/Policy/utils/types';
import { useWhyDidYouUpdate } from 'src/utils/hooks';

import {
  storeSelector,
  templateSelector,
  usePolicyContext,
} from '@Policy/store';
import AdvancedOptionModal from '@Policy/AdvancedThreatProtection/PolicyTemplate/Components/AdvancedOptionModal';
import { kfAdvancedOptionConfigSelector } from '@Policy/store/filters/keywordExtraction';

function KfNotification() {
  const { t } = useTranslation();

  // get store from context
  const contextStore = usePolicyContext();
  const policySelector = templateSelector(contextStore)<DlpPolicyItem>;
  // get store selector
  const contextSelector = storeSelector(contextStore);
  // get state and action from store
  const ntfAdminIntervalNum = policySelector(
    (s) => s.tmKeywordfilters?.notification.ntfAdminIntervalNum
  );
  const ntfAdminIntervalType = policySelector(
    (s) => s.tmKeywordfilters?.notification.ntfAdminIntervalType
  );
  const ntfAdminMessage = policySelector(
    (s) => s.tmKeywordfilters?.notification.ntfAdminMessage
  );
  const ntfAdminNotifySettingType = policySelector(
    (s) => s.tmKeywordfilters?.notification.ntfAdminNotifySettingType
  );
  const ntfAdminSubject = policySelector(
    (s) => s.tmKeywordfilters?.notification.ntfAdminSubject
  );
  const ntfEnableNotifyAdmin = policySelector(
    (s) => s.tmKeywordfilters?.notification.ntfEnableNotifyAdmin
  );
  const ntfEnableNotifyRecipient = policySelector(
    (s) => s.tmKeywordfilters?.notification.ntfEnableNotifyRecipient
  );
  const ntfInternalRecipientMessage = policySelector(
    (s) => s.tmKeywordfilters?.notification.ntfInternalRecipientMessage
  );
  const ntfInternalRecipientSubject = policySelector(
    (s) => s.tmKeywordfilters?.notification.ntfInternalRecipientSubject
  );
  const ntfToAccount = policySelector(
    (s) => s.tmKeywordfilters?.notification.ntfToAccount
  );
  const ntfAdminOccurenceNum = policySelector(
    (s) => s.tmKeywordfilters?.notification.ntfAdminOccurenceNum
  );
  const ntfRecipientGroupId = policySelector(
    (s) => s.tmKeywordfilters?.notification.ntfRecipientGroupId
  );
  const ntfRecipientGroupEnabled = policySelector(
    (s) => s.tmKeywordfilters?.notification.ntfRecipientGroupEnabled
  );
  const recipientGroups = contextSelector((s) => s.recipientGroups);
  const setKfNtfState = contextSelector((s) => s.setKfNtfState);

  // local state
  const handleNtfEnableAdminChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setKfNtfState({
        ntfEnableNotifyAdmin: e.target.checked ? 1 : 0,
      });
    },
    []
  );
  const handleNtfAdminToAccountChange = useCallback((toAccount: string) => {
    setKfNtfState({ ntfToAccount: toAccount });
  }, []);
  const handleNtfAdminNotifySettingTypeChange = useCallback(
    (notifySettingType: number) => {
      setKfNtfState({
        ntfAdminNotifySettingType: notifySettingType,
      });
    },
    []
  );
  const handleNtfAdminSubjectChange = useCallback((subject: string) => {
    setKfNtfState({ ntfAdminSubject: subject });
  }, []);
  const handleNtfAdminMessageChange = useCallback((message: string) => {
    setKfNtfState({ ntfAdminMessage: message });
  }, []);
  const handleNtfAdminIntervalNumChange = useCallback((intervalNum: number) => {
    setKfNtfState({ ntfAdminIntervalNum: intervalNum });
  }, []);
  const handleNtfAdminIntervalTypeChange = useCallback(
    (intervalType: number) => {
      setKfNtfState({ ntfAdminIntervalType: intervalType });
    },
    []
  );
  const handleNtfAdminOccurenceNumChange = useCallback(
    (occurenceNum: number) => {
      setKfNtfState({ ntfAdminOccurenceNum: occurenceNum });
    },
    []
  );
  const handleNtfRecipientGroupIdChange = useCallback(
    (recipientGroupId: number) => {
      setKfNtfState({ ntfRecipientGroupId: recipientGroupId });
    },
    []
  );
  const handleNtfRecipientGroupEnabledChange = useCallback(
    (enabled: EnableDisableStatus) => {
      setKfNtfState({ ntfRecipientGroupEnabled: enabled });
    },
    []
  );
  const handleNtfEnableRecipientChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setKfNtfState({
        ntfEnableNotifyRecipient: e.target.checked ? 1 : 0,
      });
    },
    []
  );
  const handleNtfInternalRecipientSubjectChange = useCallback(
    (subject: string) => {
      setKfNtfState({ ntfInternalRecipientSubject: subject });
    },
    []
  );
  const handleNtfInternalRecipientMessageChange = useCallback(
    (message: string) => {
      setKfNtfState({ ntfInternalRecipientMessage: message });
    },
    []
  );
  useWhyDidYouUpdate('Antispam ActionNotification', {
    ntfAdminIntervalNum,
    ntfAdminIntervalType,
    ntfAdminMessage,
    ntfAdminNotifySettingType,
    ntfAdminSubject,
    ntfEnableNotifyAdmin,
    ntfEnableNotifyRecipient,
    ntfInternalRecipientMessage,
    ntfInternalRecipientSubject,
    ntfToAccount,
    ntfAdminOccurenceNum,
    ntfRecipientGroupId,
    recipientGroups,
  });
  return (
    <div>
      <Box ml="1px" mt="16px" width="100%">
        <Flex direction="column">
          <TitleLabel title={t('policy.notification')} />
          <Tabs mt="24px">
            <TabList>
              <ButtonTab>{t('policy.notification.admin')}</ButtonTab>
              <ButtonTab>{t('policy.notification.user')}</ButtonTab>
            </TabList>
            <TabPanels py="24px">
              <TabPanel>
                <NotifyAdmin
                  status={ntfEnableNotifyAdmin}
                  toAccount={ntfToAccount}
                  notifySettingType={ntfAdminNotifySettingType}
                  subject={ntfAdminSubject}
                  message={ntfAdminMessage}
                  intervalNum={ntfAdminIntervalNum}
                  intervalType={ntfAdminIntervalType}
                  occurenceNum={ntfAdminOccurenceNum}
                  recipientGroupId={ntfRecipientGroupId}
                  recipientGroups={recipientGroups}
                  recipientGroupEnabled={ntfRecipientGroupEnabled}
                  setStatus={handleNtfEnableAdminChange}
                  setToAccount={handleNtfAdminToAccountChange}
                  setNotifySettingType={handleNtfAdminNotifySettingTypeChange}
                  setSubject={handleNtfAdminSubjectChange}
                  setMessage={handleNtfAdminMessageChange}
                  setIntervalNum={handleNtfAdminIntervalNumChange}
                  setIntervalType={handleNtfAdminIntervalTypeChange}
                  setOccurenceNum={handleNtfAdminOccurenceNumChange}
                  setRecipientGroupId={handleNtfRecipientGroupIdChange}
                  setRecipientGroupEnabled={
                    handleNtfRecipientGroupEnabledChange
                  }
                />
              </TabPanel>
              <TabPanel>
                <NotifyUser
                  status={ntfEnableNotifyRecipient}
                  subject={ntfInternalRecipientSubject}
                  message={ntfInternalRecipientMessage}
                  setStatus={handleNtfEnableRecipientChange}
                  setSubject={handleNtfInternalRecipientSubjectChange}
                  setMessage={handleNtfInternalRecipientMessageChange}
                />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Flex>
      </Box>
    </div>
  );
}
export const KfBasicAction = () => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore)<DlpPolicyItem>;
  const kfCollaborationNotifyType = policySelector(
    (s) => s.tmKeywordfilters?.kfCollaborationNotifyType
  );
  const setKfState = contextSelector((s) => s.setKfState);
  return (
    <Flex alignItems="center" mb="12px">
      <FormLabel label={t('policy.label.action')} />
      <Switch
        value={kfCollaborationNotifyType}
        checked={!!kfCollaborationNotifyType}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setKfState({
            kfCollaborationNotifyType: Number(e.target.checked),
          });
        }}
      />
      <Text ml="8px">
        {kfCollaborationNotifyType === 0
          ? t(`policy.status.off`)
          : t(`policy.status.on`)}
      </Text>
    </Flex>
  );
};
export const KfAdvancedAction = ({
  availableTokenShow,
  replaceFileNameShow,
}: {
  replaceFileNameShow: boolean;
  availableTokenShow: boolean;
}) => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore);
  // get state and action from store
  const advancedOptionConfig = contextSelector(
    kfAdvancedOptionConfigSelector,
    isEqual
  );
  const setKfState = contextSelector((s) => s.setKfState);
  // local state
  const [isVisible, setIsVisible] = React.useState<boolean>(false);
  // advanced optino
  const handleAdvancedOptionClose = useCallback(() => {
    setIsVisible(false);
  }, []);
  const handleAdvancedOptionSave = useCallback(
    ({
      replaceFileName,
      replaceText,
    }: {
      replaceFileName: string;
      replaceText: string;
    }) => {
      // save config
      setKfState({
        // kfReplacementFileName: replaceFileName,
        kfReplacementText: replaceText,
      });
      // close the modal
      setIsVisible(false);
    },
    []
  );
  useWhyDidYouUpdate('KeywordExtraction KfAdvancedAction', {
    advancedOptionConfig,
    isVisible,
  });
  return (
    <>
      <Link mr="24px" onClick={() => setIsVisible(!isVisible)}>
        {t('policy.action.advanced.title')}
      </Link>
      <AdvancedOptionModal
        replacementTextDesc={t(
          'policy.action.replaceAction.quarantineOrDelete.desc'
        )}
        availableTokenShow={availableTokenShow}
        replaceFileNameShow={replaceFileNameShow}
        isVisible={isVisible}
        onClose={handleAdvancedOptionClose}
        config={advancedOptionConfig}
        saveConfig={handleAdvancedOptionSave}
      />
    </>
  );
};
const ActionNotification = ({
  advancedOptionShow = true,
  replaceFileNameShow = true,
  availableTokenShow = false,
}: {
  advancedOptionShow?: boolean;
  replaceFileNameShow?: boolean;
  availableTokenShow?: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <div>
      <Box ml="1px" mt="16px" width="100%">
        <Flex direction="column">
          <TitleLabel title={t('policy.label.action')} mb="24px" />
          <KfBasicAction />
          {advancedOptionShow ? (
            <Flex mb="24px" mt="16px">
              {advancedOptionShow ? (
                <KfAdvancedAction
                  replaceFileNameShow={replaceFileNameShow}
                  availableTokenShow={availableTokenShow}
                />
              ) : null}
            </Flex>
          ) : null}
          <TitleLabel title={t('policy.label.notification')} />
          <KfNotification />
        </Flex>
      </Box>
    </div>
  );
};

export default React.memo(ActionNotification);
